import { CardActions as MuiCardActions, type CardActionsProps as MuiCardActionsProps } from '@mui/material';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

const ACTIONS_ALIGNMENT = { justifyContent: 'flex-end' } as const;

type Props = WithoutStyleOverrides<MuiCardActionsProps>;

export function CardActions(props: Props) {
  return <MuiCardActions {...props} sx={ACTIONS_ALIGNMENT} />;
}

export type { Props as CardActionsProps };
